<div class="chip form-control">
	<ul class="selected-list">
		<li class="badge selected-list--item" *ngFor="let item of addedValues; let i = index">
			<span class="ellipsis">{{ item }}</span>

			<span
				role="button"
				class="lui--r selected-list--remove def-focus"
				[title]="('remove' | translate) + ' ' + item"
				(click)="removeItem(i)">
				<lu-icon icon="times"></lu-icon>
			</span>
		</li>
		<li class="selected-list--item">
			<input
				[type]="to.type"
				class="input-search"
				(blur)="onBlur(input.value)"
				[placeholder]="to.placeholder"
				(keydown.enter)="addValue(input, $event)"
				(keyup)="to.inputValue = input.value"
				[formlyAttributes]="field"
				[class.is-invalid]="showError"
				[ngClass]="{ 'has-error': showError }"
				[attr.hasValue]="formControl?.value !== null"
				#input />
		</li>
	</ul>
</div>
